import React from 'react';
import { FormattedMessage } from 'react-intl';
import useTradeListItemsInSellingClosing from '../../../_shared/hooks/trade/useTradeListItemsInSellingClosing';
import TradeCardEmpty from '../../TradeCardEmpty';
import { CardType } from '../../../_shared/types/trade';

const SellingClosing = () => {
  const [tradeListItems] = useTradeListItemsInSellingClosing();

  if (tradeListItems.length !== 0) {
    return null;
  }

  return (
    <>
      <TradeCardEmpty
        variant={CardType.PLAIN}
        header={<FormattedMessage id="list.empty.sell.closing.outbid.header" />}
        content={
          <FormattedMessage id="list.empty.sell.closing.outbid.content" />
        }
      />
    </>
  );
};

export default SellingClosing;
